import React from 'react';
import classes from './PerformanceBoardCard.module.css';
import Button from '../../UI/Button/Button';
import { IsListEmpty } from '../../../utilities/CommonMethods';

export default function PerformanceBoardCard(props) {
    // console.log("List: ", props)
    return (
        <div className={classes.PerformanceCard}>
            {
                !IsListEmpty(props.studentsList)
                    ? <>
                        <div className={classes.PerformanceCardHeading}>
                            <span>{props.title}</span>
                            <span>Overall Grade</span>
                        </div>
                        {props.studentsList.map((item, index) => (
                            <div className={classes.PerformanceCardText} key={index}>
                                <div className={classes.PerformanceCardImg}>
                                    <img src={item.profilePic} alt="user-profile-pic" className={classes.ProfilePic} />
                                    <span>{item.name}</span>
                                </div>
                                <div className={classes.PerformanceText}>{item.grade}%</div>
                            </div>
                        ))
                        }
                        <hr className={classes.Divider} />
                        <div className={classes.ViewModuleText}>
                            <Button
                                label="VIEW ALL"
                                padding="0"
                                fontSize="14px"
                                margin="0"
                                styleclass="TextOnlyButtonBlue"
                                clicked={props.onViewAllClicked}
                            />
                        </div>
                    </>
                    : <>
                        <div className={classes.PerformanceCardHeading}>
                            <span>{props.title}</span>
                            <span>Overall Grade</span>
                        </div>
                        <p className={classes.NoDataText}><i>Data not available</i></p>
                    </>
            }
        </div>
    )
}
